<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- BARRA DE AÇÕES -->
            <div class="row mb-2 align-items-center">
              <!-- BARRA DE PESQUISA -->
              <div class="col mb-2">
                <div class="search-box">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search"
                      placeholder="Pesquise por Nome, Código ou Tipo..."
                      @keyup.enter="doSearch"
                    />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <!-- FILTRO STATUS -->
              <div class="col-auto mb-2">
                <select class="form-control" v-model="statusFilter" @change="doSearch">
                  <option value="">Todos os Status</option>
                  <option value="stored">Guardado</option>
                  <option value="returned">Devolvido</option>
                </select>
              </div>

              <!-- BOTÃO LOCAIS -->
              <div class="col-auto mb-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="openLocationsModal"
                >
                  <i class="bx bx-map-pin mr-1"></i> Gerenciar Locais
                </button>
              </div>

              <!-- BOTÃO TIPOS -->
              <div class="col-auto mb-2">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="openItemTypesModal"
                >
                  <i class="bx bx-category mr-1"></i> Gerenciar Tipos
                </button>
              </div>
            </div>

            <!-- LOADING -->
            <div v-if="loading" class="text-center py-4">
              <b-spinner variant="primary"></b-spinner>
              <p class="mt-2">Carregando...</p>
            </div>

            <!-- TABELA -->
            <div class="table-responsive" v-else>
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="25%">Participante</th>
                    <th width="10%">Código</th>
                    <th width="10%">Foto</th>
                    <th width="12%">Tipo</th>
                    <th width="10%">Local</th>
                    <th width="12%">Entrada</th>
                    <th width="12%">Saída</th>
                    <th width="9%">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="items.length === 0">
                    <td colspan="8" class="text-center py-4 text-muted">
                      Nenhum item encontrado
                    </td>
                  </tr>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                    class="link"
                  >
                    <!-- PARTICIPANTE -->
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="avatar-initials mr-2">
                          {{ getInitials(item.participant_name) }}
                        </div>
                        <div>
                          <h5 class="font-size-14 mb-0">{{ item.participant_name }}</h5>
                          <p class="text-muted mb-0 font-size-12">{{ item.participant_email }}</p>
                        </div>
                      </div>
                    </td>

                    <!-- CÓDIGO -->
                    <td>
                      <span class="badge badge-soft-dark font-size-12">{{ item.code }}</span>
                    </td>

                    <!-- FOTO -->
                    <td>
                      <img
                        v-if="item.photo"
                        :src="item.photo"
                        class="item-photo"
                        @click="openPhotoModal(item.photo)"
                        alt=""
                      />
                      <span v-else class="text-muted">-</span>
                    </td>

                    <!-- TIPO -->
                    <td style="text-transform: capitalize;">{{ item.custom_type_name || item.type_name }}</td>

                    <!-- LOCAL -->
                    <td>{{ item.location_name || '-' }}</td>

                    <!-- ENTRADA -->
                    <td>{{ formatDateTime(item.stored_at) }}</td>

                    <!-- SAÍDA -->
                    <td>{{ item.returned_at ? formatDateTime(item.returned_at) : '-' }}</td>

                    <!-- STATUS -->
                    <td>
                      <span
                        class="badge font-size-12 p-2"
                        :class="item.status === 'stored' ? 'badge-warning' : 'badge-success'"
                      >
                        {{ item.status === 'stored' ? 'Guardado' : 'Devolvido' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- PAGINAÇÃO -->
            <div class="row" v-if="!loading && items.length > 0">
              <div class="col">
                <div class="float-left">
                  Total de registros: <b>{{ totalRows }}</b>
                </div>
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL LOCAIS -->
    <locations-modal ref="locationsModal" />

    <!-- MODAL TIPOS -->
    <item-types-modal ref="itemTypesModal" />

    <!-- MODAL FOTO -->
    <b-modal
      v-model="showPhotoModal"
      title="Foto do Item"
      hide-footer
      centered
      size="lg"
    >
      <div class="text-center">
        <img :src="selectedPhoto" class="img-fluid" alt="" style="max-height: 500px;" />
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import LocationsModal from './modals/LocationsModal.vue'
import ItemTypesModal from './modals/ItemTypesModal.vue'
import { fetchItems } from '@/modules/storage/service/storageService'
import appConfig from '@/app.config'

export default {
  components: {
    Layout,
    LocationsModal,
    ItemTypesModal
  },
  name: 'StorageAdmin',
  page: {
    title: 'Histórico Guarda Volumes',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data: function () {
    return {
      loading: true,
      search: '',
      statusFilter: '',
      items: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 20,
      showPhotoModal: false,
      selectedPhoto: null
    }
  },
  mounted: function () {
    this.loadItems()
  },
  methods: {
    getInitials: function (name) {
      if (!name) return '?'
      var parts = name.split(' ')
      if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase()
      }
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
    },
    formatDateTime: function (dateStr) {
      if (!dateStr) return '-'
      var date = new Date(dateStr)
      var day = String(date.getDate()).padStart(2, '0')
      var month = String(date.getMonth() + 1).padStart(2, '0')
      var year = date.getFullYear()
      var hours = String(date.getHours()).padStart(2, '0')
      var minutes = String(date.getMinutes()).padStart(2, '0')
      return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes
    },
    loadItems: function () {
      var self = this
      self.loading = true

      var params = {
        limit: self.perPage,
        page: self.currentPage,
        include: 'participant,location,itemType'
      }

      if (self.search) {
        params.search = self.search
      }

      if (self.statusFilter) {
        params.status = self.statusFilter
      }

      fetchItems(params)
        .then(function (response) {
          self.loading = false
          var data = response.data || response

          self.items = data.map(function (item) {
            // Participant pode vir como objeto direto ou com .data (Fractal)
            var participant = item.participant
            if (participant && participant.data) {
              participant = participant.data
            }

            // Location pode vir como objeto direto ou com .data (Fractal)
            var location = item.location
            if (location && location.data) {
              location = location.data
            }

            // Item type pode vir como objeto direto ou com .data (Fractal)
            var itemType = item.item_type
            if (itemType && itemType.data) {
              itemType = itemType.data
            }

            return {
              id: item.id,
              code: item.code,
              custom_type_name: item.custom_type_name,
              photo: item.photo_url || item.photo,
              status: item.status,
              stored_at: item.stored_at,
              returned_at: item.returned_at,
              participant_name: participant ? participant.name : 'N/A',
              participant_email: participant ? participant.email : '',
              type_name: itemType ? itemType.name : item.type_name || 'N/A',
              location_name: location ? location.name : '-'
            }
          })

          if (response.meta && response.meta.pagination) {
            self.totalRows = response.meta.pagination.total
            self.currentPage = response.meta.pagination.current_page
          } else {
            self.totalRows = self.items.length
          }
        })
        .catch(function (error) {
          self.loading = false
          console.error('Erro ao carregar itens:', error)
        })
    },
    doSearch: function () {
      this.currentPage = 1
      this.loadItems()
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadItems()
    },
    openLocationsModal: function () {
      this.$refs.locationsModal.open()
    },
    openItemTypesModal: function () {
      this.$refs.itemTypesModal.open()
    },
    openPhotoModal: function (photo) {
      this.selectedPhoto = photo
      this.showPhotoModal = true
    }
  }
}
</script>

<style scoped>
.link { cursor: pointer; }
.table-responsive { min-height: 300px; }
.float-sm-end { float: right; }

.avatar-initials {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #556ee6;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.item-photo {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s;
}

.item-photo:hover {
  transform: scale(1.1);
}

.search-box .position-relative .search-icon {
  position: absolute;
  font-size: 18px;
  color: #74788d;
  left: 13px;
  top: 0;
  line-height: 38px;
}

.search-box .form-control {
  padding-left: 40px;
}
</style>
